import { DateTime } from 'luxon';
import { makeAutoObservable } from 'mobx';
import { ExchangeRateApiResponse, ExchangeRateSource } from '../../api/ExchangeRatesApi';
import { DateFormatString, MonthFormatString } from '../../config/Config';
import { ExchangeRateRange } from '../../config/Constants';
import { CurrencyCode } from '../../config/CurrencyCode';
import translate from '../../language/translate';

export class ExchangeRate {
  from: CurrencyCode = CurrencyCode.AED;
  to: CurrencyCode = CurrencyCode.AFN;
  range: ExchangeRateRange = ExchangeRateRange.DAY;
  rate: number = 0.0;
  date: DateTime = null;
  source: ExchangeRateSource = ExchangeRateSource.fixer;

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: ExchangeRateApiResponse): ExchangeRate {
    const rate = new ExchangeRate();

    rate.from = apiData.from as CurrencyCode;
    rate.to = apiData.to as CurrencyCode;
    rate.range = apiData.range as ExchangeRateRange;
    rate.rate = apiData.rate;
    rate.date = DateTime.fromISO(apiData.date);
    rate.source = apiData.source as ExchangeRateSource;

    return rate;
  }

  static one(curr: CurrencyCode): ExchangeRate {
    const rate = new ExchangeRate();
    rate.from = curr;
    rate.to = curr;
    rate.rate = 1.0;
    return rate;
  }

  toKey = (): string => {
    let key = `${this.source}:${this.from}:${this.to}:${this.range}`;
     
    if (this.date.isValid) {
      return `${key}:${this.date.toISODate()}`;
    }
    return `${key}:fixed`;
  };

  get dateDescription(): string {
    switch (this.range) {
      case ExchangeRateRange.DAY:
        return this.date.toFormat(DateFormatString);
      case ExchangeRateRange.MONTH:
        return translate('Global.Fx.MONTH', { month: this.date.toFormat(MonthFormatString) });
      case ExchangeRateRange.ALL:
        return translate('Global.Fx.ALL');
    }
  } 
}
